import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import type TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useExploreServiceFilterCounts from '@alltrails/explore-service/hooks/useExploreServiceFilterCounts';
import TrailheadVectorOverlay from '@alltrails/maps/components/TrailheadVectorOverlay/TrailheadVectorOverlay';
import { isTrailheadsExploreVariant } from '@alltrails/maps/utils/trailheadPinVariant';
import { useAppSelector } from '@/utils/redux';

type Props = {
  activeTrailheadId?: number;
  cardLocation: TrailCardLocation;
  detailedCardLocation: CardLocation;
  mapLocation: MapLocation | string;
  handleFavoriteClick?: (trailId: number) => void;
};

const TrailheadMapComponents = ({ activeTrailheadId, cardLocation, detailedCardLocation, mapLocation, handleFavoriteClick }: Props) => {
  const trailheadsVariant = useExperiments()['web-disco-rm-trailheads-explore-variants']?.value;
  const mapPadding = useAppSelector(state => state.explore.mapPadding);
  const { adminFilterCount, filterCount } = useExploreServiceFilterCounts();

  return (
    <TrailheadVectorOverlay
      activeTrailheadId={activeTrailheadId}
      cardLocation={cardLocation}
      detailedCardLocation={detailedCardLocation}
      handleFavoriteClick={handleFavoriteClick}
      hasFiltersApplied={Boolean(adminFilterCount || filterCount)}
      mapLocation={mapLocation}
      mapPadding={mapPadding}
      pinVariant={isTrailheadsExploreVariant(trailheadsVariant) ? trailheadsVariant : undefined}
    />
  );
};

export default TrailheadMapComponents;
